import { createContext } from 'react';

type ContextType = {
  onClose: () => void;
};

export const MenuContext = createContext<ContextType>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose: () => {},
});
